import type { AifiLevel } from '@/domains/pages/ai-proficiency/constants';
import { METHODOLOGY_DIMENSIONS } from '@/domains/pages/ai-proficiency/constants';

/** Per-dimension target scores for radar green dashed line (placeholder until API-backed). */
export type LevelDimensionTargets = Record<string, number>;

/**
 * Target score applied to every methodology dimension at a level.
 * When all dimensions share the same value T, the weighted AIFI formula yields T.
 */
export const STATIC_LEVEL_DIMENSION_TARGET_SCORES: Record<AifiLevel, number> = {
  Novice: 48,
  Beginner: 62,
  Practitioner: 76,
  Expert: 90,
};

function buildUniformDimensionTargets(score: number): LevelDimensionTargets {
  return Object.fromEntries(METHODOLOGY_DIMENSIONS.map((dimension) => [dimension.key, score]));
}

/** Static per-level dimension targets for upskilling radar charts. */
export const STATIC_LEVEL_DIMENSION_TARGETS: Record<AifiLevel, LevelDimensionTargets> = {
  Novice: buildUniformDimensionTargets(STATIC_LEVEL_DIMENSION_TARGET_SCORES.Novice),
  Beginner: buildUniformDimensionTargets(STATIC_LEVEL_DIMENSION_TARGET_SCORES.Beginner),
  Practitioner: buildUniformDimensionTargets(STATIC_LEVEL_DIMENSION_TARGET_SCORES.Practitioner),
  Expert: buildUniformDimensionTargets(STATIC_LEVEL_DIMENSION_TARGET_SCORES.Expert),
};
